import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import getAppConfigurations from 'helpers/app/getAppConfigurations';
import RouteManager from './RouteManager';
import './Vendor';
import 'sass/bootstrap.scss';
import 'sass/app.scss';

export const App = () => {
  const { store } = getAppConfigurations();

  return (
    <Provider store={store}>
      <Router basename="/">
        <RouteManager />
      </Router>
    </Provider>
  );
};

export default App;
